import type { ParseKeys } from 'i18next';

export enum PageNames {
  PenViewer = 'penviewer',
  Automation = 'automation',
  BargeControl = 'bargecontrol',
  CameraCheck = 'cameracheck',
  Dashboard = 'Dashboard',
  DeviceConfig = 'deviceconfig',
  EventStream = 'eventstream',
  HybridPower = 'hybrid-power',
  Inventory = 'inventory',
  Layouts = 'layouts',
  UpCycle = 'upcycle',
  OpcUaServer = 'opcuaserver',
  Settings = 'settings',
  Vortex = 'vortex',
  OrbitOne = 'orbitone',
  NetworkHealth = 'networkhealth',
  SiteSetup = 'sitesetup',
}

export const pageNameDict: Record<PageNames, ParseKeys> = {
  'hybrid-power': 'pages.hybridPower',
  Dashboard: 'pages.dashboard',
  penviewer: 'pages.penViewer',
  automation: 'pages.automation',
  bargecontrol: 'pages.bargeControl',
  cameracheck: 'pages.cameraCheck',
  deviceconfig: 'pages.deviceConfig',
  eventstream: 'pages.eventStream',
  inventory: 'pages.inventory',
  layouts: 'pages.layouts',
  upcycle: 'pages.upCycle',
  opcuaserver: 'pages.opcUaServer',
  settings: 'pages.settings',
  vortex: 'pages.vortex',
  orbitone: 'pages.orbitOne',
  networkhealth: 'pages.networkHealth',
  sitesetup: 'pages.siteSetup',
};

export type StaticPageNames = keyof typeof PageNames;
